export default {
  props: {
    html: {
      type: String,
      default: ""
    },
    show: {
      type: Boolean,

      default() {
        return false;
      }

    }
  },
  emits: {
    'update:show': state => {
      if (typeof state === 'boolean') {
        return true;
      } else {
        console.warn('type of modal show is not boolean!');
        return false;
      }
    }
  },

  data() {
    return {};
  },

  components: {},
  computed: {},

  mounted() {},

  methods: {
    closeModal() {
      this.$emit('update:show', false);
    }

  }
};